import { Users } from 'lucide-react';
import type { Conversation } from '../../../api/chat';
import Avatar from './Avatar';
import { fmtTime } from '../utils/format';

function ConvRow({
  c, name, isActive, online, subtitle, onClick,
}: {
  c: Conversation; name: string; isActive: boolean; online?: boolean; subtitle?: string; onClick: () => void;
}) {
  const last = c.last_message;
  const unread = c.unread_count || 0;

  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-3 py-2 flex items-center gap-3 transition-colors relative focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset ${
        isActive
          ? 'bg-blue-50'
          : 'hover:bg-gray-100'
      }`}
    >
      {isActive && <div className="absolute left-0 top-2 bottom-2 w-0.5 bg-blue-600 rounded-r" />}

      {c.type === 'dm' ? (
        <Avatar name={name} size={10} online={online} />
      ) : (
        <div className="relative flex-shrink-0">
          <div className="w-10 h-10 bg-gradient-to-br from-gray-600 to-gray-700 rounded-full flex items-center justify-center shadow-sm">
            <Users size={16} className="text-white" />
          </div>
        </div>
      )}

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 mb-0.5">
          <span className={`text-sm font-semibold truncate ${isActive ? 'text-blue-700' : 'text-gray-900'}`}>
            {name}
          </span>
          <div className="flex items-center gap-1.5 flex-shrink-0">
            {last && (
              <span className="text-[11px] text-gray-500">{fmtTime(last.created_at)}</span>
            )}
            {unread > 0 && (
              <span className="bg-blue-600 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 shadow-sm">
                {unread > 99 ? '99+' : unread}
              </span>
            )}
          </div>
        </div>
        {subtitle && (
          <p className="text-[11px] text-gray-500 truncate leading-tight">{subtitle}</p>
        )}
        <p className={`text-[13px] truncate ${unread > 0 ? 'text-gray-900 font-medium' : 'text-gray-500'}`}>
          {last?.is_deleted
            ? <em className="not-italic text-gray-400">This message was deleted</em>
            : last?.content || (last ? '📎 Attachment' : 'No messages yet')}
        </p>
      </div>
    </button>
  );
}

export default ConvRow;
